import React, { useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';
import moment from 'moment';

import useStyles from 'components/QrForm/style';
import TextInput from 'components/ui/TextInput';
import { useLocation } from 'react-router-dom';
import ButtonCustom from 'components/ui/Button';
import { getDateFormat, getIncidentDataOnReqType, getObjectSize } from 'functions/helper';
import {
  getBitrixDeals,
  sendQrReport,
  addBitrixContact,
  addBitrixDealContact,
  getBitrixContact,
} from 'api/apiRequest';
import { TYPES_OF_INCIDENTS, DEAL_CRM_PARAMS } from 'constants/main';
import { useAlert } from 'hooks';

const FORM_FIELDS = [
  {
    name: 'UF_CRM_1567577307',
    type: 'text',
    label: 'Номер терминала',
    reqName: 'idTerminal',
    required: true,
  },
  {
    name: 'UF_CRM_1624823525575',
    type: 'text',
    label: 'Адрес терминала',
    reqName: 'terminalAddress',
    required: true,
  },
  {
    name: 'UF_CRM_1627363082015',
    type: 'text',
    label: 'Сумма внесенных средств',
    reqName: 'amount',
    required: true,
  },
  {
    name: 'UF_CRM_1624827739698',
    type: 'text',
    label: 'Номер счета',
    reqName: 'account',
    required: true,
  },
  {
    name: 'UF_CRM_1624827784333',
    type: 'text',
    label: 'Сервис',
    reqName: 'service',
    required: true,
  },
  {
    name: 'UF_CRM_1624828331426',
    type: 'text',
    label: 'Дата и время платежа',
    reqName: 'paymentDate',
    required: true,
  },
];

const FORM_FIELDS_AD = [
  {
    name: 'PHONE',
    type: 'mask',
    label: 'Контактный телефон',
    required: true,
    mask: '+7(999) 999 99 99',
  },
];

const QrForm = () => {
  const defaultTitle = 'QR-Отчет об ошибке';
  const isDealExistErrMsg = 'Отчет по вашей проблеме уже был отправлен.';
  const classes = useStyles();
  const [reportSend, setReportSend] = useState(false);
  const { setSuccessMessage, setErrorMessage } = useAlert();
  const [reportTitle, setReportTitle] = useState('');
  const [showForm, setShowForm] = useState(true);
  const search = useLocation().search;
  const [showSendBtn, setShowSendBtn] = useState(false);
  const [fieldsError, setFieldsError] = useState([]);

  useEffect(() => {
    let errCount = 0;
    let paramValue = '';

    FORM_FIELDS.forEach((field) => {
      if (field.required) {
        paramValue = getValue(field.reqName, true);

        if (paramValue === '') {
          errCount++;
        }
      }
    });

    if (errCount === 0) {
      setShowSendBtn(true);
    } else {
      setErrorMessage('Невозможно отправить отчет. Получены неполные данные.');
    }

    const typeReq = getValue('type');
    const incidentData = getIncidentDataOnReqType(typeReq);

    setReportTitle(incidentData.title);

    // check is consist deal in bitrix
    const filter = {
      UF_CRM_1624827739698: getValue('account'),
      UF_CRM_1624827784333: getValue('service'),
      UF_CRM_1567577307: getValue('idTerminal'),
      '>=UF_CRM_1624828331426': getDateBitrixFormat(getValue('paymentDate')),
      UF_CRM_1627363082015: getValue('amount'),
      UF_CRM_1624828528996: incidentData.bitrixType,
    };

    getBitrixDeals(filter).then((res) => {
      if (res.total > 0) {
        res.result.forEach((item) => {
          if (item.UF_CRM_1624828331426 === getValue('paymentDate')) {
            setShowForm(false);
          }
        });
      }
    });
  }, []);

  const getDateBitrixFormat = (date) => moment(date, 'YYYYMMDDhhmmss').format('YYYY-MM-DDThh:mm:ss+03:00');

  const getValue = (reqName, format = false) => {
    const value = new URLSearchParams(search).get(reqName) || '';

    switch (reqName) {
      case 'paymentDate': {
        if (format) {
          return getDateFormat(value);
        }

        return getDateBitrixFormat(value);
      }
      case 'terminalAddress': {
        const region = getValue('region');

        return region ? `${region}, ${value}` : value;
      }
      default:
        return value;
    }
  };

  const getPhoneValueFormat = (value) => {
    const valueNoFormat = value.replace(/[^+\d]+/g, '').substring(1);

    return valueNoFormat;
  };

  const validateForm = () => {
    const errors = {};

    FORM_FIELDS_AD.forEach((field) => {
      let value = document.getElementById(field.name).value;

      if (field.required === true) {
        if (field.name === 'PHONE') {
          value = getPhoneValueFormat(value);

          if (value !== '' && value.length < 11) {
            errors[field.name] = 'Неверно заполнено поле';
          }
        }

        if (value === '') {
          errors[field.name] = 'Поле обязательно для заполнения';
        }
      }
    });

    if (getObjectSize(errors) > 0) {
      setFieldsError(errors);
    } else {
      sendErrorReport();
    }
  };

  const sendErrorReport = () => {
    const data = DEAL_CRM_PARAMS;
    const type = getValue('type');
    let paramValue = '';

    FORM_FIELDS.forEach((field) => {
      if (field.required) {
        paramValue = getValue(field.reqName);
        data[field.name] = paramValue;
      }
    });

    if (type !== '') {
      data.TITLE = reportTitle;
      const bitrixType = TYPES_OF_INCIDENTS.filter(
        (item) => item.type === Number(type)
      );

      if (bitrixType.length > 0) { data.UF_CRM_1624828528996 = bitrixType[0].bitrixId; }
    } else data.TITLE = defaultTitle;

    // check contact
    const phone = document.getElementById('PHONE').value;
    let contactId = 0;

    const contactFilter = { PHONE: phone };
    const contactFields = { PHONE: [{ VALUE: phone, VALUE_TYPE: 'WORK' }] };

    getBitrixContact(contactFilter).then((res) => {
      if (res.total > 0) {
        contactId = res.result[0].ID;
        handlerSendQrReport(data, contactId);
      } else {
        addBitrixContact(contactFields).then((result) => {
          if (result) {
            contactId = result;
            handlerSendQrReport(data, contactId);
          }
        });
      }
    });
  };

  const handlerSendQrReport = (data, contactId) => {
    sendQrReport(data).then((res) => {
      if (res) {
        addBitrixDealContact(res, { CONTACT_ID: contactId }).then(() => {
          setReportSend(true);
          setSuccessMessage('Отчет успешно отправлен');
        });
      } else {
        setReportSend(false);
        setErrorMessage('Ошибка! Отчет не отправлен');
      }
    });
  };

  return (
    <div className={classes.content}>
      <div className={`mainCont ${classes.contentForm}`}>
        <Typography variant="h1">
          Отправка отчета{reportTitle !== '' && `: ${reportTitle}`}
        </Typography>
        <form>
          {!showForm && isDealExistErrMsg}
          {showForm && (
            reportSend ? (
              'Отчет успешно отправлен'
            ) : (
              <>
                {FORM_FIELDS.map((field,) => (
                  <TextInput
                    name={field.name}
                    disabled
                    label={field.label}
                    type={field.type}
                    value={getValue(field.reqName, true)}
                    key={field.name}
                  />
                ))}
                {FORM_FIELDS_AD.map((field,) => (
                  <TextInput
                    name={field.name}
                    required={field.required}
                    label={field.label}
                    mask={field.mask}
                    disabled={false}
                    key={field.name}
                    type={field.type}
                    error={fieldsError[field.name]}
                    id={field.name}
                  />
                ))}
                {showSendBtn && (
                  <ButtonCustom onClick={validateForm} color="primary">
                    Отправить
                  </ButtonCustom>
                )}
              </>
            )
          )}
        </form>
      </div>
    </div>
  );
};

export default QrForm;
